import React from 'react';
import { Paper, Tooltip } from '@mui/material';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

const SidebarToggle = ({ isOpen, onClick, sx }) => (
    <Tooltip title={isOpen ? "Collapse sidebar" : "Expand sidebar"} placement="right">
        <Paper
            elevation={3}
            onClick={onClick}
            className="toggle-button"
            sx={{
                position: 'fixed',
                width: 24,
                height: 48,
                borderRadius: '0 8px 8px 0',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                cursor: 'pointer',
                bgcolor: 'background.paper',
                transition: 'all 0.2s ease',
                '&:hover': {
                    bgcolor: 'action.hover',
                    width: 28
                },
                zIndex: 1300,
                opacity: 0.8,
                ...sx
            }}
        >
            {isOpen ? <ChevronLeft /> : <ChevronRight />}
        </Paper>
    </Tooltip>
);

export default SidebarToggle;
